import { useLocalStorage } from '@rehooks/local-storage';

export function useAcceptedTermsAt() {
  return useLocalStorage<string>('acceptedTermsAt');
}
